import { LunaStreamsClient } from 'api-bindings/luna-streams';

export const lunaStreamsClient = new LunaStreamsClient();
